import React, { Component } from 'react';
import { Toolbar } from 'react-md';
import KebabMenu from './KebabMenu';
import { trackEvent } from '../../util/analytics';
import './Header.scss';
import logoPath from './logo-white.svg';

class Header extends Component {
  handleClick = () => {
    window.open('https://www.datatheorem.com/', '_blank');
    trackEvent({
      category: 'External',
      action: 'Logo',
    });
  };

  render() {
    const { config } = this.props;
    return (
      <div className="header-wrapper">
        <Toolbar
          fixed
          colored
          actions={<KebabMenu id="toolbar-colored-kebab-menu" />}
        >
          <div
            className="logo-wrapper"
            onClick={this.handleClick}
            role="button"
            tabIndex="0"
            onKeyPress={this.handleClick}
          >
            <img className="logo" src={logoPath} alt="Data theorem Logo" />
          </div>

          <div className="title-wrapper">
            <div className="title-text">
              {config.siteTitle}&nbsp;{config.siteSubtitle}
            </div>
          </div>
        </Toolbar>
      </div>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/Header.jsx